import { useAutoAnimate } from '@formkit/auto-animate/react';
import classNames from 'classnames';
import { FunctionComponent, ReactNode, useState } from 'react';
import BButton from './BButton';

interface BTabsProps {
  bodyClasses?: string;
  tabClasses?: string;
  wrapperClasses?: string;
  tabsWrapperClasses?: string;
  tabs: TabItem[];
}

export interface TabItem {
  title: ReactNode;
  children: ReactNode;
}

const BTabs: FunctionComponent<BTabsProps> = ({
  bodyClasses,
  tabClasses,
  wrapperClasses,
  tabsWrapperClasses,
  tabs,
}) => {
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [parent] = useAutoAnimate<HTMLDivElement>();

  return (
    <div className={classNames('b-tabs', wrapperClasses)}>
      <div
        className={classNames(
          tabsWrapperClasses,
          'border-b border-primary-900'
        )}
      >
        {tabs.map((tab, idx) => (
          <BButton
            priority={activeTabIndex === idx ? 'contained' : 'text'}
            variant={activeTabIndex === idx ? 'primary' : 'secondary'}
            className={classNames(
              'b-tab',
              'rounded-b-none !px-5 !py-2 shadow-none'
            )}
            onClick={() => setActiveTabIndex(idx)}
            key={`tab-${idx}`}
          >
            {tab.title}
          </BButton>
        ))}
      </div>
      <div ref={parent} className={classNames(bodyClasses, 'mt-4')}>
        {tabs.map((tab, idx) =>
          idx === activeTabIndex ? (
            <div key={`tab-child-${idx}`} className={classNames(tabClasses)}>
              {tab.children}
            </div>
          ) : null
        )}
      </div>
    </div>
  );
};

export default BTabs;
